import {GameServer} from "@repo/shared";

function pluralize(value: number, unit: string): string {
  return `${value} ${value === 1 ? unit : unit + "s"}`;
}

export function timeFor(data: Date) {
  return "for " + timeInternal(data);
}

export function timeSince(data: Date) {
  return timeInternal(data) + " ago";
}

function timeInternal(date: Date) {
  // @ts-expect-error - Subtracting two dates returns a number
  const seconds = Math.floor((new Date() - date) / 1000);

  let interval = seconds / 31536000;
  if (interval >= 1) {
    // Using months as the resolution for 1+ years
    const months = Math.floor(seconds / 2592000);
    return pluralize(months, "month");
  }

  interval = seconds / 86400;
  if (interval >= 1) {
    const days = Math.floor(interval);
    return pluralize(days, "day");
  }

  interval = seconds / 3600;
  if (interval >= 1) {
    const hours = Math.floor(interval);
    return pluralize(hours, "hour");
  }

  interval = seconds / 60;
  if (interval >= 1) {
    const minutes = Math.floor(interval);
    return pluralize(minutes, "minute");
  }

  return "< 1 minute";
}

export const formatCompletionSteps = (steps: number): string => {
  const totalSeconds = steps / GameServer.STEPS_PER_SECOND;
  const minutes = Math.floor(totalSeconds / 60); // Extract total minutes
  const seconds = totalSeconds % 60; // Extract remaining seconds
  return `${minutes.toString().padStart(2, "0")}:${seconds.toFixed(3).padStart(6, "0")}`;
};
